import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { userRegisteredGuard } from './shared/guards/user-registered.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'calculations/list',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'form',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/form/form.routes').then((m) => m.FORM_ROUTES),
  },
  {
    path: 'grid',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/grid/grid.routes').then((m) => m.GRID_ROUTES),
  },
  {
    path: 'graph',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/graph/graph.routes').then((m) => m.GRAPH_ROUTES),
  },
  {
    path: 'master-data',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/master-data/master-data.routes').then((m) => m.MASTER_DATA_ROUTES),
  },
  {
    path: 'calculations',
    canActivate: [MsalGuard, userRegisteredGuard],
    loadChildren: () => import('./features/calculations/calculation.routes').then((m) => m.CALCULATION_ROUTES),
  },
  {
    // The help reader, opened from the tree in the help panel. An ordinary route on purpose, so
    // leaving a page this way runs its guards like any other navigation.
    path: 'help',
    canActivate: [MsalGuard],
    loadChildren: () => import('./features/help/help.routes').then((m) => m.HELP_ROUTES),
  },
  {
    path: 'no-registered',
    canActivate: [MsalGuard],
    loadComponent: () => import('./features/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 401,
      title: 'User is not registered in PreCalc application',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: 'no-permission',
    canActivate: [MsalGuard],
    loadComponent: () => import('./features/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 403,
      title: 'Permission denied.',
      description: 'Please contact your application administrator',
      url: '',
      label: '',
    },
  },
  {
    path: '404',
    loadComponent: () => import('./features/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 404,
      title: 'Page not found.',
      description: '',
      url: '/',
      label: 'Go To Recent Calculations List',
    },
  },
  {
    path: '500',
    loadComponent: () => import('./features/error-page/error-page.component').then((m) => m.ErrorPageComponent),
    data: {
      icon: 'bi bi-gear-wide-connected',
      status: 500,
      title: 'An unexpected error occurred',
      description: '',
      url: '/',
      label: 'Go To Recent Calculations List',
    },
  },
  {
    path: '**',
    redirectTo: '404',
  },
];
